import { reactive, ref } from 'vue';
export let phoneCode = reactive({
  list: [
    { value: '', autofocus: true },
    { value: '', autofocus: false },
    { value: '', autofocus: false },
    { value: '', autofocus: false },
    { value: '', autofocus: false },
    { value: '', autofocus: false }
  ]
});

/** 手机验证码输入 change */
export function phoneCodeChange (event, item, index) {
  let input = document.getElementsByClassName('phone-code-input');
  if (item.value.length == 6) {
    let numArr = item.value.split('');
    phoneCode.list.forEach((item, i) => {
      item.value = numArr[i];
    });
    input && input[5].focus();
    return;
  } else if (item.value.length > 1) {
    item.value = item.value.split('')[0];
  }
  const value = event.data || event.target.value;

  if (event.inputType === 'insertText' && value.length === 1) {
    input && input[index + 1] && input[index + 1].focus();
  }

  if (event.inputType === 'deleteContentBackward' && value.length === 0) {
    input && input[index - 1] && input[index - 1].focus();
  }
}

let positionIndex = 0;
export function phoneCodeKeydown (event, index) {
  let input = document.getElementsByClassName('phone-code-input');
  if (event.code === 'ArrowLeft') {
    positionIndex++;
    console.log('left index: ', positionIndex);
    if (positionIndex === 2) {
      input[index - 1] && input[index - 1].focus();
      positionIndex = 0;
    }
  }

  if (event.code === 'ArrowRight') {
    positionIndex++;
    console.log('right index: ', positionIndex);
    if (positionIndex === 2) {
      input[index + 1] && input[index + 1].focus();
      positionIndex = 0;
    }
  }
}

/** 提交前处理六位验证码 */
export function prePhoneCode () {
  return phoneCode.list.map(item => item.value).join('');
}

export let second = ref(0);
/** 倒计时 */
export function countDown () {
  second.value = 60;
  let countInterval = setInterval(() => {
    if (second.value > 1) {
      second.value--;
    } else {
      clearInterval(countInterval);
      second.value = 0;
    }
  }, 1000);
}
